import { Button } from 'admin/components/atoms/Buttons';
import Select from 'admin/components/atoms/Select';
import LabeledSelect from 'admin/components/molecules/LabeledSelect';
import ShopSelector from 'admin/components/organisms/ShopSelector';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const SelectGroup = styled.div`
  display: flex;
  ${Select} {
    width: 250px !important;
  }
  ${ShopSelector} > * {
    width: 250px;
  }
  ${Button} {
    width: 80px;
    margin-top: 0;
  }
`;

const SelectedShopsEditor = ({ available_shops = [], onChangeShops, designatedMoney, ...rest }) => {
  const [shop, setShop] = useState();
  const [selectedShopOps, setSelectedShopOps] = useState([]);

  useEffect(() => {
    if (available_shops && available_shops.length > 0) {
      setSelectedShopOps(available_shops.map((s) => ({ label: s.name, value: s.id, shop: s })));
    } else {
      setSelectedShopOps([]);
    }
  }, [available_shops]);

  useEffect(() => {
    onChangeShops(selectedShopOps.map((op) => op.shop));
  }, [selectedShopOps]);

  const handleChnage = (ops) => {
    setSelectedShopOps(ops);
  };
  const handleShopSelect = (selected) => {
    setShop(selected);
  };
  const addSelectedShops = (e) => {
    e.preventDefault();

    if (selectedShopOps.every((op) => op.value !== shop.id)) {
      setSelectedShopOps(selectedShopOps.concat([{ label: shop.name, value: shop.id, shop }]));
    }
  };

  return (
    <div {...rest}>
      <SelectGroup>
        <ShopSelector onChangeShop={handleShopSelect} designatedMoney={designatedMoney} />
        <Button variant="outline" onClick={addSelectedShops} disabled={!shop}>
          追加
        </Button>
      </SelectGroup>
      <LabeledSelect
        id="shopSelector"
        labelText="選択済み"
        options={[]}
        isMulti="true"
        onChange={handleChnage}
        value={selectedShopOps}
        placeholder="店舗を選んでください"
        readOnly
      />
    </div>
  );
};

export default styled(SelectedShopsEditor)`
  ${LabeledSelect} {
    width: 80%;
    & > * {
      width: 100%;
    }
  }
`;
